import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, media } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export const useApi = (path, deps = []) => {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    api.get(path).then((r) => { if (alive) setState({ data: r.data, loading: false, error: null }); })
      .catch((e) => { if (alive) setState({ data: null, loading: false, error: e?.response?.status || "error" }); });
    return () => { alive = false; };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  return state;
};

export const Kept = ({ title = "Kept within the family", text = "These stories are private for now. Enter a family member code to see them.", era = "sepia", testid = "kept-panel" }) => {
  const { site } = useSite() || {};
  const ph = site?.eras?.[era]?.[1] || site?.eras?.[era]?.[0];
  return (
    <div className="relative overflow-hidden rounded-2xl border border-[#C9A24B]/35 min-h-[340px] flex items-end" data-testid={testid}>
      {ph && <img src={media(ph.url)} alt="From the family archive" className="absolute inset-0 w-full h-full object-cover kenburns" style={{ filter: "sepia(.7) brightness(.45)" }} />}
      <div className="relative p-8 md:p-12 max-w-xl">
        <span className="grid place-items-center w-12 h-12 rounded-full border border-[#C9A24B] text-[#C9A24B]"><Lock size={18} /></span>
        <h3 className="mt-6 font-display text-3xl text-[#F6EFE0]">{title}</h3>
        <p className="mt-3 text-[#F6EFE0]/85">{text}</p>
        <Link to="/gate" className="btn-gold mt-8" data-testid={`${testid}-gate-link`}>Family Members Only</Link>
      </div>
    </div>
  );
};

export const Loading = ({ label = "Opening the album" }) => (
  <div className="py-24 flex flex-col items-center gap-4 text-[#C9A24B]" data-testid="loading-state">
    <span className="w-10 h-10 rounded-full border border-[#C9A24B]/30 border-t-[#C9A24B] animate-spin" />
    <p className="font-mono-x text-xs tracking-[0.3em]">{label.toUpperCase()}</p>
  </div>
);
